import * as types from "../action/ActionType";
import { STATEMENT_INITIAL } from "../store/InitialStore";

export default function BillingStatementFilterReducer(state = STATEMENT_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.BILLING_STATEMENT_SELECT:
      return {
        ...state, // Spread the existing state
        ...payload, // Merge with the new payload
      };
    default:
      return state;
  }
}
